import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { CircularProgress, Grid, MenuItem, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { SnackAlertContext } from "../../../context/SnackAlertContext";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import SelectTime from "../Time/SelectTime";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

let DEFAULT_HOURLY_START_TIME = dayjs("2018-01-01 5:00 -07:00");
let DEFAULT_HOURLY_STOP_TIME = dayjs("2018-01-01 13:30 -07:00");
let DEFAULT_HOURLY_LUNCH_DURATION = 30;
export default function CreateEmployee() {
  let navigate = useNavigate();
  const { authToken, ezorder } = useContext(AuthContext);
  const [inValidRole, setInvalidRole] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const { openSnackMessage } = useContext(SnackAlertContext);

  const createNewEmployee = async (requestBody) => {
    setIsLoading(true);
    // console.log(requestBody);

    try {
      const response = await ezorder.post(`/users`, requestBody, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      navigate(`/employees`);
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Employee Name is Required"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Email Address is Required"),
    // password: Yup.string()
    //   .required("Password Required")
    //   .max(
    //     20,
    //     "Password Must Contain between 8-20 Characters, One Uppercase, One Lowercase, One Number and One Special Character"
    //   )
    //   .matches(
    //     passwordRegex,
    //     "Password Must Contain between 8-20 Characters, One Uppercase, One Lowercase, One Number and One Special Character"
    //   ),
    // workStartTime: yup
    //   .date("Invalid Time")
    //   .when("salaryType", (salaryType, schema) => salaryType == "HOURLY"),
    // workStopTime: yup.date("Invalid Time").nullable(),
    role: Yup.string().required("Role is required"),
    salaryType: Yup.string("Salary Type is required").required(
      "Salary Type is required"
    ),
  });

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phone: "",
      role: "EZORDER_EMPLOYEE",
      salaryType: "HOURLY",
      jobTitle: "",
      workStartTime: DEFAULT_HOURLY_START_TIME,
      workStopTime: DEFAULT_HOURLY_STOP_TIME,
      lunchDurationMinutes: DEFAULT_HOURLY_LUNCH_DURATION,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let {
        fullName,
        email,
        phone,
        role,
        salaryType,
        jobTitle,
        workStartTime,
        workStopTime,
        lunchDurationMinutes,
      } = values;
      if (values.salaryType == "HOURLY") {
        if (!values.workStartTime || !values.workStartTime.isValid()) {
          formik.setFieldError("workStartTime", "Invalid Start Time");
          return;
        } else if (!values.workStopTime || !values.workStopTime.isValid()) {
          formik.setFieldError("workStopTime", "Invalid Stop Time");
          return;
        } else {
          let workDurationMinutes = values.workStopTime.diff(
            values.workStartTime,
            "minutes"
          );
          createNewEmployee({
            fullName,
            email,
            phone,
            role,
            salaryType,
            jobTitle,
            workStartTime: workStartTime
              ? workStartTime.utc().format("HH:mm Z")
              : null,
            // workStopTime,
            workDurationMinutes,
            lunchDurationMinutes,
          });
        }
      } else {
        createNewEmployee({
          fullName,
          email,
          phone,
          role,
          salaryType,
          jobTitle,
          workStartTime: workStartTime
            ? workStartTime.utc().format("HH:mm Z")
            : null,
          // workStopTime,
          workDurationMinutes: null,
          lunchDurationMinutes,
        });
      }
    },
  });

  // useEffect(() => {
  //   if (
  //     formik.values.workStartTime &&
  //     formik.values.workStartTime.isValid() &&
  //     formik.values.workStopTime &&
  //     formik.values.workStopTime.isValid()
  //   ) {
  //     // let timeLocal = formik.values.workStartTime.format("HH:mm Z");
  //     // let timeUTC = formik.values.workStartTime.utc().format("HH:mm Z");
  //     // console.log(`LOCAL: ${timeLocal}`);
  //     // console.log(`UTC: ${timeUTC}`);
  //     // console.log("BUILD DATE WITH SPECIFIC TIME USING PARSED TIMES");
  //     // console.log(`LOCAL: ${dayjs(`2024-09-19 ${timeLocal}`).toDate()}`);
  //     // console.log(`UTC: ${dayjs(`2024-09-19 ${timeUTC}`).toDate()}`);

  //     console.log(
  //       formik.values.workStartTime.utc().format("MM/DD/YY HH:mm Z"),
  //       "_________",
  //       formik.values.workStopTime.utc().format("MM/DD/YY HH:mm Z"),
  //       "_________",
  //       formik.values.workStopTime.diff(formik.values.workStartTime, "minutes")
  //     );
  //   }
  // }, [formik.values]);

  useEffect(() => {
    console.log(formik.errors);
  }, [formik.errors]);

  return (
    <Box sx={{}}>
      <Typography component="h1" variant="h5">
        Add New Employee
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              required
              fullWidth
              id="fullName"
              label="Full Name"
              name="fullName"
              value={formik.values.fullName}
              onChange={formik.handleChange}
              autoComplete="name"
              onBlur={formik.handleBlur}
              error={
                formik.touched.fullName &&
                formik.errors.fullName &&
                Boolean(formik.errors.fullName && true)
              }
              helperText={
                formik.touched.fullName &&
                formik.errors.fullName &&
                `${formik.errors.fullName}`
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              autoComplete="email"
              onBlur={formik.handleBlur}
              error={
                formik.touched.email &&
                formik.errors.email &&
                Boolean(formik.errors.email && true)
              }
              helperText={
                formik.touched.email &&
                formik.errors.email &&
                `${formik.errors.email}`
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              id="jobTitle"
              label="Job Title"
              name="jobTitle"
              value={formik.values.jobTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.jobTitle &&
                formik.errors.jobTitle &&
                Boolean(formik.errors.jobTitle && true)
              }
              helperText={
                formik.touched.jobTitle &&
                formik.errors.jobTitle &&
                `${formik.errors.jobTitle}`
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Phone"
              name="phone"
              value={formik.values.phone}
              onChange={formik.handleChange("phone")}
              onBlur={formik.handleBlur}
              error={
                formik.touched.phone &&
                formik.errors.phone &&
                Boolean(formik.errors.phone && true)
              }
              helperText={
                formik.touched.phone &&
                formik.errors.phone &&
                `${formik.errors.phone}`
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              select
              fullWidth
              required
              label="App Role"
              value={formik.values.role}
              onChange={formik.handleChange("role")}
              onBlur={formik.handleBlur}
              error={
                formik.touched.role &&
                formik.errors.role &&
                Boolean(formik.errors.role && true)
              }
              helperText={
                formik.touched.role &&
                formik.errors.role &&
                `${formik.errors.role}`
              }
            >
              <MenuItem value="EZORDER_ADMIN">Admin</MenuItem>
              <MenuItem value="EZORDER_FOREMAN">Foreman</MenuItem>
              <MenuItem value="EZORDER_EMPLOYEE">Shop</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              select
              fullWidth
              required
              label="Salary Type"
              value={formik.values.salaryType}
              onChange={(e) => {
                let salaryType = e.target.value;
                if (salaryType == "HOURLY") {
                  formik.setValues((prev) => ({
                    ...prev,
                    salaryType,
                    workStartTime: DEFAULT_HOURLY_START_TIME,
                    workStopTime: DEFAULT_HOURLY_STOP_TIME,
                    lunchDurationMinutes: DEFAULT_HOURLY_LUNCH_DURATION,
                  }));
                } else {
                  // SALARY OR EMPTY, clear out the start, stop, lunch
                  formik.setValues((prev) => ({
                    ...prev,
                    salaryType,
                    workStartTime: null,
                    workStopTime: null,
                    lunchDurationMinutes: null,
                  }));
                }
              }}
              onBlur={formik.handleBlur}
              error={
                formik.touched.salaryType &&
                formik.errors.salaryType &&
                Boolean(formik.errors.salaryType && true)
              }
              helperText={
                formik.touched.salaryType &&
                formik.errors.salaryType &&
                `${formik.errors.salaryType}`
              }
            >
              <MenuItem value="HOURLY">Hourly</MenuItem>
              <MenuItem value="SALARY">Salary</MenuItem>
            </TextField>
          </Grid>
          {formik.values.salaryType == "HOURLY" && (
            <>
              <Grid item xs={12} sm={4}>
                {/* <TimePicker
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      // onBlur={formik.handleBlur}
                      error={
                        // formik.touched.workStartTime &&
                        formik.errors.workStartTime &&
                        Boolean(formik.errors.workStartTime && true)
                      }
                      helperText={
                        // formik.touched.workStartTime &&
                        formik.errors.workStartTime &&
                        `${formik.errors.workStartTime}`
                      }
                    />
                  )}
                  value={formik.values.workStartTime}
                  label="Start Time"
                  onChange={(newValue) => {
                    console.log("Start Time", newValue);
                    formik.setFieldValue("workStartTime", newValue);
                  }}
                  minTime={dayjs("2018-01-01 0:00 -07:00")}
                  maxTime={formik.values.workStopTime}
                /> */}
                <SelectTime
                  timezone={DEFAULT_TIMEZONE}
                  // onBlur={formik.handleBlur}
                  error={
                    // formik.touched.workStartTime &&
                    formik.errors.workStartTime &&
                    Boolean(formik.errors.workStartTime && true)
                  }
                  helperText={
                    // formik.touched.workStartTime &&
                    formik.errors.workStartTime &&
                    `${formik.errors.workStartTime}`
                  }
                  value={formik.values.workStartTime}
                  label="Start Time"
                  onUpdate={(newValue) => {
                    console.log("Start Time", newValue);
                    formik.setFieldValue("workStartTime", newValue);
                  }}
                  // minTime={dayjs("2018-01-01 0:00 -07:00")}
                  maxTime={formik.values.workStopTime}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                {/* <TimePicker
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      // onBlur={formik.handleBlur}
                      error={
                        // formik.touched.workStopTime &&
                        formik.errors.workStopTime &&
                        Boolean(formik.errors.workStopTime && true)
                      }
                      helperText={
                        // formik.touched.workStopTime &&
                        formik.errors.workStopTime &&
                        `${formik.errors.workStopTime}`
                      }
                    />
                  )}
                  value={formik.values.workStopTime}
                  label="Stop Time"
                  onChange={(newValue) => {
                    console.log(typeof newValue);
                    formik.setFieldValue("workStopTime", newValue);
                  }}
                  minTime={formik.values.workStartTime}
                  maxTime={dayjs("2018-01-01 23:59 -07:00")}
                /> */}
                <SelectTime
                  timezone={DEFAULT_TIMEZONE}
                  // onBlur={formik.handleBlur}
                  error={
                    // formik.touched.workStartTime &&
                    formik.errors.workStopTime &&
                    Boolean(formik.errors.workStartTime && true)
                  }
                  helperText={
                    // formik.touched.workStopTime &&
                    formik.errors.workStopTime &&
                    `${formik.errors.workStopTime}`
                  }
                  value={formik.values.workStopTime}
                  label="Stop Time"
                  onUpdate={(newValue) => {
                    console.log(typeof newValue);
                    formik.setFieldValue("workStopTime", newValue);
                  }}
                  minTime={formik.values.workStartTime}
                  // maxTime={dayjs("2018-01-01 23:59 -07:00")}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  type="number"
                  size="small"
                  fullWidth
                  id="lunchDurationMinutes"
                  label="Lunch Duration (Minutes)"
                  name="lunchDurationMinutes"
                  value={formik.values.lunchDurationMinutes}
                  onChange={formik.handleChange}
                  autoComplete="name"
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.lunchDurationMinutes &&
                    formik.errors.lunchDurationMinutes &&
                    Boolean(formik.errors.lunchDurationMinutes && true)
                  }
                  helperText={
                    formik.touched.lunchDurationMinutes &&
                    formik.errors.lunchDurationMinutes &&
                    `${formik.errors.lunchDurationMinutes}`
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
      </LocalizationProvider>

      <Box sx={{ m: 1, position: "relative" }}>
        <LoadingButton
          loading={isLoading}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={isLoading}
          onClick={() => {
            formik.handleSubmit();
          }}
        >
          Save
        </LoadingButton>
        {isLoading && (
          <CircularProgress
            size={24}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
    </Box>
  );
}
